import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(apiError(e.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen hero-grain flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-xl overflow-hidden shadow-2xl">
        <div className="gold-line h-1.5" />
        <div className="p-8">
          <div className="text-center mb-6">
            <img src="/logo.jpg" alt="emblem" className="w-16 h-16 mx-auto rounded-full object-cover ring-1 ring-[#E6C687]" />
            <h1 className="font-display text-2xl font-bold text-[#0B2E63] mt-3">Admin Portal</h1>
            <p className="text-sm text-[#5A6270]">HCABA, Jabalpur — Website Management</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-[#5A6270]">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="mt-1 w-full border border-[#E5DECF] rounded-lg px-3 py-2.5 focus:outline-none focus:border-[#E6C687]" data-testid="login-email" />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-[#5A6270]">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="mt-1 w-full border border-[#E5DECF] rounded-lg px-3 py-2.5 focus:outline-none focus:border-[#E6C687]" data-testid="login-password" />
            </div>
            {err && <p className="text-sm text-[#C53030]" data-testid="login-error">{err}</p>}
            <button type="submit" disabled={loading} className="btn-gold w-full rounded-lg py-2.5 font-semibold disabled:opacity-60" data-testid="login-submit">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
          <Link to="/" className="block text-center text-xs text-[#123B7A] mt-5 hover:underline">← Back to website</Link>
        </div>
      </div>
    </div>
  );
}
